import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import Login from "../pages/Login";
import React from "react";
import { SkeletonPage } from './Skeleton';

interface Props {
  children: React.ReactNode;
}



export default function AuthGate({ children }: Props): React.ReactElement {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (firebaseUser: any) => {
      setUser(firebaseUser);
      setLoading(false);
    });
  }, []);

  if (loading) return <SkeletonPage variant="auth" label="Checking your session" />;

  if (!user)
    return (
      <div style={{ maxWidth: "40%", margin: "auto" }}>
        <Login />
      </div>
    );

  return <>{children}</>; // This ensures it's a JSX.Element
}
